const s = {
  name: "BusinessShirt",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M25,23h10v-2H25V23z"/>
		<path class="st0" d="M31,0H9v4.3l-9,3V40h40V7.3l-9-3V0z M2,8.7l7-2.3v9l10-3V38H2V8.7z M38,38H21V12.3l10,3v-9l7,2.3V38z
			 M29,12.7l-7.1-2.1L29,3.4V12.7z M12.4,2h15.2L20,9.6L12.4,2z M18.1,10.5L11,12.7V3.4L18.1,10.5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as BusinessShirt
};
